










import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {ActiveProvide} from "@/support/reactive"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component
export default class JdsMeridianLayout extends Vue {
    @ActiveProvide('jds.meridian.open') provideOpen = false;
    @Prop({type: Boolean}) open!: boolean;

    @Watch('open', {immediate: true})
    updateProvideOpen(val: boolean) {
        this.provideOpen = val;
    }
}
